/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actionTypes';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import * as Constants from '../../../../../SharedModules/AppConstants';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';

export const tabValue = (value) => {
  return { type: actiontypes.VIEW_TAB, payload: value };
};

export const clearMaintainRbtRedux = () => {
  return { type: actiontypes.MAINTAINRBT_REDUX_CLEAR };
};

export const errorMsg = (value) => {
  return { type: actiontypes.VIEW_ERROR_MSG, payload: value };
};

export const fieldErr = (value) => {
  return { type: actiontypes.VIEW_FIELD_ERR, payload: value };
};

export const commentsData = (value) => {
  return { type: actiontypes.COMMENTS_FLAG, payload: value };
};

export const defaultAuditCheck = (value) => {
  return { type: actiontypes.DEFAULT_AUDIT, payload: value };
};

export const saveEnable = (value) => {
  return { type: actiontypes.ENABLE_SAVE, payload: value };
};

export const copyData = (value) => {
  return { type: actiontypes.COPY_DATA, payload: value };
};

export const resetStore = () => {
  return { type: actiontypes.RESET_STORE };
};

export const customReset = () => {
  return { type: actiontypes.CUSTOM_RESET };
};

export const pgmDetail = (value) => {
  return { type: actiontypes.REBATE_PGM_DETAIL, payload: value };
};

export const getRebatePgmDetail = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.VIEW_REBATE_PGM, values)
    .then((response) => {
      dispatch(pgmDetail(response.data?.data?.[0]));
    })
    .catch((response) => {
      dispatch(pgmDetail({}));
    });
};

export const getUraGridList = (program) => (dispatch) => {
  let payload = {
    rebateProg: program,
    rpcParamTypeCdForUraSourceCd: 'URA_SOURCE_CD',
    rpcParamTypeCdForChgUraFormPmtInd: 'CHG_URA_FROM_PMT_IND',
    calcTypeCd: 'URA',
  };
  return axios
    .post(serviceEndPoint.REBATE_URA_GRID_LIST, payload)
    .then((response) => {
      let data = response.data?.rebateProgramUraGrid?.[0];
      data = {
        rpcUrPayment: data.rpcUrPayment.map((o) => {
          o.id = uuidv4();
          return o;
        }),
        rpcUraCal: data.rpcUraCal.map((o) => {
          o.id = uuidv4();
          return o;
        }),
        rpcUraSource: data.rpcUraSource.map((o) => {
          o.id = uuidv4();
          return o;
        }),
      };
      dispatch({ type: actiontypes.URA_GRID_DATA, payload: data });
      dispatch({
        type: actiontypes.COPY_URA_GRID_DATA,
        payload: JSON.stringify(data),
      });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.URA_GRID_DATA, payload: {} });
      dispatch({ type: actiontypes.COPY_URA_GRID_DATA, payload: '{}' });
    });
};

export const getLastFrozenQtr = (code) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_LAST_FROZEN_QTR, { rebateProgramCd: code })
    .then((response) => {
      dispatch({
        type: actiontypes.LAST_FROZEN_QTR,
        payload: response.data?.data?.lastFrozenInvoiceQtr,
      });
    })
    .catch(() => dispatch({ type: actiontypes.LAST_FROZEN_QTR, payload: '' }));
};

export const saveUpdateRebatePgm = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_UPDATE_REBATE_PGM, payload)
    .then((response) => response.data)
    .catch(() => null);
};

export const getIntGridList = (code) => (dispatch) => {
  let payload = {
    rebateProgramCd: code,
    rpcParamTypeCdForFedRegPct: 'FED_REG_PCT',
    rpcParamTypeCdForFedFpPct: 'FED_FP_PCT',
    calcTypeCd: 'INT',
  };
  return axios
    .post(serviceEndPoint.REBATE_INT_GRID_LIST, payload)
    .then((response) => {
      let data = response.data?.rebateProgramIntShareResponseVO?.[0];
      data = {
        rpcCalcPctVOIntShareFedaralList:
          data.rpcCalcPctVOIntShareFedaralList.map((obj) => {
            obj.id = uuidv4();
            obj.rpcParamValue = parseFloat(obj.rpcParamValue).toFixed(2);
            return obj;
          }),
        rpcParamVoIntShareFedaralFamiliList:
          data.rpcParamVoIntShareFedaralFamiliList.map((obj) => {
            obj.id = uuidv4();
            obj.rpcParamValue = parseFloat(obj.rpcParamValue).toFixed(2);
            return obj;
          }),
        rpcParamVoIntShareIntCalList: data.rpcParamVoIntShareIntCalList.map(
          (obj) => {
            obj.id = uuidv4();
            return obj;
          }
        ),
      };
      dispatch({ type: actiontypes.INT_GRID_DATA, payload: data });
      dispatch({
        type: actiontypes.COPY_INT_GRID_DATA,
        payload: JSON.stringify(data),
      });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.INT_GRID_DATA, payload: {} });
      dispatch({ type: actiontypes.COPY_INT_GRID_DATA, payload: '{}' });
    });
};
// Audit Grid Data
export const getAuditGridList = (code) => (dispatch) => {
  let payload = {
    rebateProgramCd: code,
    testGroupCd: ['C', 'I'],
    testTypeCd: [
      'UNA',
      'RES',
      'AES',
      'SRA',
      'RLA',
      'STR',
      'IDC',
      'UNP',
      'RGR',
      'RGP',
      'RGL',
    ],
  };
  return axios
    .post(serviceEndPoint.REBATE_AUDIT_GRID_LIST, payload)
    .then((response) => {
      let data = response.data?.rpcParamTestVO2;
      dispatch({ type: actiontypes.AUDIT_GRID_DATA, payload: data });
      // dispatch({
      //   type: actiontypes.COPY_AUDIT_GRID_DATA,
      //   payload: JSON.stringify(data),
      // });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.AUDIT_GRID_DATA, payload: {} });
      // dispatch({ type: actiontypes.COPY_AUDIT_GRID_DATA, payload: '{}' });
    });
};

export const getUnitTypeAuditGridList = (code) => (dispatch) => {
  let payload = {
    rebateProgramCd: code,
    testGroupCd: 'C',
    testTypeCd: 'UNT',
    codeDomainKey: 'UNIT_TYPE_CD',
  };
  return axios
    .post(serviceEndPoint.REBATE_UNIT_TYPE_GRID_LIST, payload)
    .then((response) => {
      let data = response.data?.rpcParamTestVO2;
      dispatch({ type: actiontypes.UNIT_TYPE_AUDIT_GRID_DATA, payload: data });
      // dispatch({
      //   type: actiontypes.COPY_UNIT_TYPE_DATA,
      //   payload: JSON.stringify(data),
      // });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.UNIT_TYPE_AUDIT_GRID_DATA, payload: {} });
      dispatch({ type: actiontypes.COPY_UNIT_TYPE_DATA, payload: '{}' });
    });
};

export const getGroupGridData = (code) => (dispatch) => {
  let payload = {
    rebateProgramCd: code,
    rpcParamTypeCdCmsRept: [
      'CMS_RPT_GROUP_NUM',
      'CMS_RPT_GROUP_NAME',
      'CMS_RPT_TITLE',
    ],
    rpcParamTypeCdCmsUtz: ['CMS_UTIL_GROUP_NUM', 'CMS_UTIL_GROUP_NAME'],
  };
  return axios
    .post(serviceEndPoint.REBATE_GROUP_GRID_LIST, payload)
    .then((response) => {
      let data = response.data?.rebateProgramGroupVO?.[0];
      data = {
        cmsReporting: data.cmsReporting.map((obj) => {
          obj.id = uuidv4();
          return obj;
        }),
        cmsUtilization: data.cmsUtilization.map((obj) => {
          obj.id = uuidv4();
          return obj;
        }),
      };
      dispatch({ type: actiontypes.GROUP_GRID_DATA, payload: data });
      dispatch({
        type: actiontypes.COPY_GROUP_GRID_DATA,
        payload: JSON.stringify(data),
      });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.GROUP_GRID_DATA, payload: {} });
      dispatch({ type: actiontypes.COPY_GROUP_GRID_DATA, payload: '{}' });
    });
};

export const getEnrollGridData = (code) => (dispatch) => {
  return axios
    .post(serviceEndPoint.EREBATE_ENROLL_GRID_LIST, {
      rebateProgramCd: code,
    })
    .then((response) => {
      let data = response.data?.rpcEnrollmentVO2?.map((obj) => {
        obj.id = uuidv4();
        return obj;
      });
      dispatch({ type: actiontypes.ENROLL_GRID_DATA, payload: data });
      dispatch({
        type: actiontypes.COPY_ENROLL_GRID_DATA,
        payload: JSON.stringify(data),
      });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.ENROLL_GRID_DATA, payload: {} });
      dispatch({ type: actiontypes.COPY_ENROLL_GRID_DATA, payload: '{}' });
    });
};

export const getCmsFreezeQtr = (code) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_CMS_FREEZE_QTR, { rebateProgramCd: code })
    .then((response) => {
      dispatch({
        type: actiontypes.CMS_FREEZE_QTR,
        payload: response.data?.data?.cmsFreezeQtrDisplay,
      });
    })
    .catch(() => dispatch({ type: actiontypes.CMS_FREEZE_QTR, payload: '' }));
};

export const getMaxQtrEnroll = (code) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_MAX_QTR_ENROLL, { rebateProgramCd: code })
    .then((response) => {
      dispatch({
        type: actiontypes.MAX_ENROLL_QTR,
        payload: response.data?.data?.maxFrozenQtrDisplay,
      });
    })
    .catch(() => dispatch({ type: actiontypes.MAX_ENROLL_QTR, payload: '' }));
};

export const getUseDefAuditsInd = (code) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_USE_DEF_AUDIT, {
      claimRebateProgramCode: code,
    })
    .then((response) => {
      let value = response.data?.useDefAuditsInd[0]?.useDefAuditsInd;
      dispatch({
        type: actiontypes.USE_DEF_AUDIT,
        payload: value,
      });
      let val = value === 1 ? true : false;
      dispatch(defaultAuditCheck(val));
    })
    .catch(() => dispatch({ type: actiontypes.USE_DEF_AUDIT, payload: '' }));
};

export const getOverrideDefaultData = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_OVERIDE_GRID_LIST, payload)
    .then((response) => {
      let data = response.data?.rebateProgramDefaultOverrideVO?.[0];
      dispatch({ type: actiontypes.DEFAULT_OVERRIDE_DATA, payload: data });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.DEFAULT_OVERRIDE_DATA, payload: {} });
    });
};

export const getOverrideSystemData = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_SYSTEM_DEFAULT_OVERIDE, payload)
    .then((response) => {
      let data = response.data?.rebateProgramUseSystemDefaultOverrideVO?.[0];
      dispatch({ type: actiontypes.SYSTEM_OVERRIDE_DATA, payload: data });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.SYSTEM_OVERRIDE_DATA, payload: {} });
    });
};

export const saveAPICall = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.CREATE_REBATE_PROGRAM, payload)
    .then((response) => {
      dispatch({ type: actiontypes.SAVE_INFO, payload: response.data });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.SAVE_INFO, payload: null });
    });
};
